/* evx-lander — behaviour shared by the EVX lander sections.
   Runs once for the whole page and re-runs when the theme editor swaps a
   section in, so settings changes stay interactive while editing. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- panels */
  function initPanels() {
    var fresh = document.querySelectorAll('.evx-lp [data-lp-anim]:not([data-lp-bound])');
    if (!fresh.length) return;
    for (var i = 0; i < fresh.length; i++) fresh[i].setAttribute('data-lp-bound', '1');

    var all = function () { return document.querySelectorAll('.evx-lp [data-lp-anim]'); };
    var revealAll = function () {
      var n = all();
      for (var k = 0; k < n.length; k++) n[k].classList.add('is-in');
    };
    var anyRevealed = function () {
      var n = all();
      for (var k = 0; k < n.length; k++) if (n[k].classList.contains('is-in')) return true;
      return false;
    };

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.28 });
    for (var j = 0; j < fresh.length; j++) io.observe(fresh[j]);

    /* The first diagram sits near the top, so it should have fired by now. If
       nothing has, the observer is not working here (in-app webviews and
       backgrounded tabs do this) and every diagram is shown outright rather
       than left as a column of blank boxes. */
    setTimeout(function () { if (!anyRevealed()) revealAll(); }, 2500);
  }

  /* ------------------------------------------------- bundles and checkout */
  var catalogue = null;   // { cartUrl, map: {"5-Pack|M": id}, price: {...} }
  var chosenSize = null;

  function readCatalogue() {
    var el = document.querySelector('.evx-lp [data-lp-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function firstSizeFor(bundle) {
    if (!catalogue) return null;
    for (var key in catalogue.map) {
      if (key.indexOf(bundle + '|') === 0) return key.split('|')[1];
    }
    return null;
  }

  /* Only the bundle buttons buy anything. Everything else on the page sends
     the reader down to the bundles first, because a size has to be picked
     before a cart link means anything. */
  function applyLinks() {
    if (!catalogue) return;
    var links = document.querySelectorAll('.evx-lp a[data-evx-cta]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var bundle = a.getAttribute('data-lp-bundle');
      if (!bundle) continue;
      var size = chosenSize || firstSizeFor(bundle);
      var id = catalogue.map[bundle + '|' + size] || catalogue.map[bundle + '|' + firstSizeFor(bundle)];
      if (id) a.setAttribute('href', catalogue.cartUrl + '/' + id + ':1');
    }
  }

  /* Sizes can carry their own prices, so the boxes follow the choice too. */
  function applyPrices() {
    if (!catalogue || !catalogue.price) return;
    var boxes = document.querySelectorAll('.evx-lp .lp-box');
    for (var i = 0; i < boxes.length; i++) {
      var link = boxes[i].querySelector('a[data-lp-bundle]');
      if (!link) continue;
      var bundle = link.getAttribute('data-lp-bundle');
      var size = chosenSize || firstSizeFor(bundle);
      var p = catalogue.price[bundle + '|' + size];
      var now = boxes[i].querySelector('[data-lp-now]');
      if (p && now) now.textContent = p;
    }
  }

  /* ------------------------------------------- send the rest to the bundles */
  function scrollToOffer(ev) {
    var target = document.getElementById('offers');
    if (!target) return;                       // no bundle section: let the link do whatever it does
    if (ev) ev.preventDefault();
    var picker = target.querySelector('[data-lp-sizes]');
    var anchor = picker || target;
    var docEl = document.scrollingElement || document.documentElement;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Images below the fold are lazy, so as they load the browser's scroll
       anchoring shifts everything underneath them. Aiming at a pixel value
       captured up front lands in the wrong place; the target is recomputed
       from the element on every frame instead, and re-checked once the page
       has had time to settle. */
    var wanted = function () {
      return Math.max(0, anchor.getBoundingClientRect().top + docEl.scrollTop - 28);
    };
    var settle = function () {
      var tries = 0;
      var again = function () {
        if (++tries > 6) return;
        var w = wanted();
        if (Math.abs(docEl.scrollTop - w) > 6) docEl.scrollTop = w;
        setTimeout(again, 160);
      };
      setTimeout(again, 120);
    };

    if (reduced) { docEl.scrollTop = wanted(); settle(); nudge(picker); return; }

    var t0 = null, from = docEl.scrollTop;
    var dur = Math.min(900, 240 + Math.abs(wanted() - from) * 0.32);
    var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      docEl.scrollTop = from + (wanted() - from) * ease(k);
      if (k < 1) requestAnimationFrame(step); else settle();
    };
    requestAnimationFrame(step);
    /* requestAnimationFrame is throttled to nothing in a hidden or backgrounded
       tab, so the easing above would never run at all. */
    setTimeout(function () { if (Math.abs(docEl.scrollTop - wanted()) > 6) { docEl.scrollTop = wanted(); settle(); } }, dur + 240);
    nudge(picker);
  }

  /* A pulse so it is obvious the size still has to be chosen. */
  function nudge(picker) {
    if (!picker) return;
    picker.classList.remove('is-asking');
    void picker.offsetWidth;
    picker.classList.add('is-asking');
    setTimeout(function () { picker.classList.remove('is-asking'); }, 1800);
  }

  function initJumpLinks() {
    var links = document.querySelectorAll('.evx-lp a[data-evx-cta]:not([data-lp-jump-bound])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      a.setAttribute('data-lp-jump-bound', '1');
      if (a.getAttribute('data-lp-bundle')) continue;   // a real buy button
      if (!document.getElementById('offers')) continue;
      a.setAttribute('href', '#offers');
      a.addEventListener('click', scrollToOffer);
    }
  }

  function initBundles() {
    catalogue = readCatalogue();

    var wraps = document.querySelectorAll('.evx-lp [data-lp-sizes]:not([data-lp-bound])');
    for (var i = 0; i < wraps.length; i++) {
      wraps[i].setAttribute('data-lp-bound', '1');
      var pressed = wraps[i].querySelector('.lp-size-b[aria-pressed="true"]');
      if (pressed && !chosenSize) chosenSize = pressed.textContent.trim();
      wraps[i].addEventListener('click', function (ev) {
        var b = ev.target.closest('.lp-size-b');
        if (!b) return;
        var all = this.querySelectorAll('.lp-size-b');
        for (var k = 0; k < all.length; k++) all[k].setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-pressed', 'true');
        chosenSize = b.textContent.trim();
        this.classList.remove('is-asking');
        applyLinks();
        applyPrices();
      });
    }
    applyLinks();
    applyPrices();
  }

  /* ------------------------------------------------------------- countdown */
  function initCountdown() {
    var els = document.querySelectorAll('.evx-lp [data-lp-countdown]:not([data-lp-bound])');
    for (var i = 0; i < els.length; i++) {
      (function (cd) {
        cd.setAttribute('data-lp-bound', '1');
        var hours = parseFloat(cd.getAttribute('data-lp-hours')) || 24;
        var key = 'evx_lander_deadline_' + Math.round(hours);
        var end;
        try { end = parseInt(sessionStorage.getItem(key) || '', 10); } catch (e) { }
        if (!end || isNaN(end) || end < Date.now()) {
          end = Date.now() + hours * 3600 * 1000;
          try { sessionStorage.setItem(key, String(end)); } catch (e) { }
        }
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var put = function (k, v) { var e = cd.querySelector('[data-cd="' + k + '"]'); if (e) e.textContent = pad(v); };
        var tick = function () {
          var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
          var d = Math.floor(s / 86400); s -= d * 86400;
          var h = Math.floor(s / 3600); s -= h * 3600;
          var m = Math.floor(s / 60); s -= m * 60;
          put('d', d); put('h', h); put('m', m); put('s', s);
        };
        tick();
        setInterval(tick, 1000);
      })(els[i]);
    }
  }

  /* --------------------------------------------------------- review filter */
  function initTabs() {
    var bars = document.querySelectorAll('.evx-lp [data-lp-tabs]:not([data-lp-bound])');
    for (var i = 0; i < bars.length; i++) {
      bars[i].setAttribute('data-lp-bound', '1');
      bars[i].addEventListener('click', function (ev) {
        var t = ev.target.closest('.lp-tab');
        if (!t) return;
        var all = this.querySelectorAll('.lp-tab');
        for (var k = 0; k < all.length; k++) all[k].setAttribute('aria-pressed', 'false');
        t.setAttribute('aria-pressed', 'true');
        var want = (t.getAttribute('data-f') || 'all').toLowerCase();
        var grid = this.parentElement.querySelector('[data-lp-rvs]');
        if (!grid) return;
        var cards = grid.querySelectorAll('.lp-rv');
        for (var j = 0; j < cards.length; j++) {
          var cat = (cards[j].getAttribute('data-c') || '').toLowerCase();
          cards[j].hidden = !(want === 'all' || cat === want);
        }
      });
    }
  }

  /* ---------------------------------------------------------- sticky button */
  function initSticky() {
    var sticky = document.querySelector('.evx-lp [data-lp-sticky]');
    if (!sticky || sticky.getAttribute('data-lp-bound')) return;
    sticky.setAttribute('data-lp-bound', '1');
    var onScroll = function () {
      var anchor = document.querySelector('.evx-lp [data-lp-sticky-after]');
      var tail = document.querySelector('.evx-lp [data-lp-sticky-until]');
      var offers = document.getElementById('offers');
      var past = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var atEnd = tail ? tail.getBoundingClientRect().top < window.innerHeight + 260 : false;
      /* No point nagging someone to jump to the bundles while they are reading them. */
      var onOffers = false;
      if (offers) {
        var r = offers.getBoundingClientRect();
        onOffers = r.top < window.innerHeight * 0.6 && r.bottom > 0;
      }
      sticky.classList.toggle('is-on', past && !atEnd && !onOffers);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------- size chart */
  function initChart() {
    var dlg = document.querySelector('.evx-lp [data-lp-chart]');
    if (!dlg || dlg.getAttribute('data-lp-bound')) return;
    dlg.setAttribute('data-lp-bound', '1');

    var open = function (ev) {
      if (ev) ev.preventDefault();
      document.body.classList.add('lp-chart-open');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    };
    var close = function () {
      document.body.classList.remove('lp-chart-open');
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    };

    var triggers = document.querySelectorAll('.evx-lp [data-lp-chart-open]');
    for (var i = 0; i < triggers.length; i++) triggers[i].addEventListener('click', open);
    var closers = dlg.querySelectorAll('[data-lp-chart-close]');
    for (var j = 0; j < closers.length; j++) closers[j].addEventListener('click', close);

    /* Clicking the backdrop is the same as clicking away. */
    dlg.addEventListener('click', function (ev) {
      if (ev.target !== dlg) return;              // a click on the panel itself, not the backdrop
      var r = dlg.getBoundingClientRect();
      var outside = ev.clientY < r.top || ev.clientY > r.bottom || ev.clientX < r.left || ev.clientX > r.right;
      if (outside) close();
    });
    dlg.addEventListener('close', function () { document.body.classList.remove('lp-chart-open'); });
  }

  function init() { initChart(); initPanels(); initBundles(); initJumpLinks(); initCountdown(); initTabs(); initSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
